module.exports = __webpack_public_path__ + "static/icons/icon-map--usa-7889e1768bafde25f304cbd181c0765d.svg";